import {
  DEFAULT_TENANT_TIMEZONE,
  dateAndTimeToTenantIso,
  formatTenantDate,
  formatTenantDateTimeRange,
  formatTenantDateTime,
  formatTenantDateWithWeekday,
  formatTenantMonthHeading,
  formatTenantTime,
  formatTenantTimeRange,
  isoToTenantDateTimeInputValue,
  tenantDateTimeInputValueToIso
} from "@madamuh/domain";

export { DEFAULT_TENANT_TIMEZONE };
export { dateAndTimeToTenantIso as tenantDateAndTimeToIso };
export {
  formatTenantDateTime,
  formatTenantDateTimeRange,
  formatTenantTimeRange,
  formatTenantDate,
  formatTenantDateWithWeekday,
  formatTenantMonthHeading,
  formatTenantTime
};
export { isoToTenantDateTimeInputValue, tenantDateTimeInputValueToIso };

export const isoToTenantLocalDateTimeInput = isoToTenantDateTimeInputValue;
export const tenantLocalDateTimeToIso = tenantDateTimeInputValueToIso;
export const formatTenantIsoDateTime = formatTenantDateTime;
export const formatTenantIsoDate = formatTenantDate;
export const formatTenantIsoTime = formatTenantTime;
